<ng-container *ngIf="isAuthenticating; else loginContent">
  <div class="authenticating-overlay">
    <mat-progress-spinner mode="indeterminate" [diameter]="40"></mat-progress-spinner>
    <span class="authenticating-label">Signing in...</span>
  </div>
</ng-container>

<ng-template #loginContent>
  <ng-container *ngIf="authChecked">

    <section class="login-section">
      <ng-container *ngIf="microsoftAuthEnabled">
        <div class="mat-elevation-z2 sign-in-button">
          <div
            class="button-header"
            (click)="isSignInDisabled() ? null : microsoftAuth()"
            [class.disabled]="isSignInDisabled()"
          >
            <mat-progress-spinner *ngIf="microsoftLoading" mode="indeterminate" [diameter]="24"></mat-progress-spinner>
            <img alt="logo" class="logo-size" src="./assets/img/microsoft_icon.svg"/>
            <span>Sign in with Microsoft</span>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="googleAuthEnabled">
        <div class="mat-elevation-z2 sign-in-button">
          <div
            class="button-header"
            (click)="isSignInDisabled() ? null : googleAuth()"
            [class.disabled]="isSignInDisabled()">
            <mat-progress-spinner *ngIf="googleLoading" mode="indeterminate" [diameter]="24"></mat-progress-spinner>
            <img alt="logo" class="logo-size" src="./assets/img/google_icon.svg"/>
            <span>Sign in with Google</span>
          </div>
        </div>
      </ng-container>
    </section>

  </ng-container>

</ng-template>
